/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewDeliveryFee
 */
export interface NewDeliveryFee {
    /**
     * 
     * @type {number}
     * @memberof NewDeliveryFee
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof NewDeliveryFee
     */
    townId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewDeliveryFee
     */
    courierId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewDeliveryFee
     */
    deliveryConfigId?: number;
}

/**
 * Check if a given object implements the NewDeliveryFee interface.
 */
export function instanceOfNewDeliveryFee(value: object): value is NewDeliveryFee {
    return true;
}

export function NewDeliveryFeeFromJSON(json: any): NewDeliveryFee {
    return NewDeliveryFeeFromJSONTyped(json, false);
}

export function NewDeliveryFeeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewDeliveryFee {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'townId': json['townId'] == null ? undefined : json['townId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'deliveryConfigId': json['deliveryConfigId'] == null ? undefined : json['deliveryConfigId'],
    };
}

export function NewDeliveryFeeToJSON(json: any): NewDeliveryFee {
    return NewDeliveryFeeToJSONTyped(json, false);
}

export function NewDeliveryFeeToJSONTyped(value?: NewDeliveryFee | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'townId': value['townId'],
        'courierId': value['courierId'],
        'deliveryConfigId': value['deliveryConfigId'],
    };
}

